import { handleApiCall } from '@/utils/handleApiCall'

export default {
  namespaced: true,
  state: {},
  actions: {
    async exception ({ commit }, message) {
      handleApiCall('exception', '', '', message)
    }
  }
}
